/* oxlint-disable sorare/use-horizontal-vertical-layout */
import isPropValid from '@emotion/is-prop-valid';
import styled from 'styled-components';

import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  gap?: Unit;
  center?: boolean;
  grow?: boolean; // used when using inside another flex element.
};

// `gap`/`center`/`grow` only feed the CSS below. styled-components drops
// unknown props for DOM targets, but not when `as` points at a component — that
// target then spreads them onto the DOM and React warns (`center={true}`).
// Supplying `shouldForwardProp` replaces that default filtering rather than
// adding to it, so DOM targets have to keep going through `isPropValid`.
const styleOnlyProps = {
  shouldForwardProp: (prop: string, target: unknown) =>
    prop !== 'gap' &&
    prop !== 'center' &&
    prop !== 'grow' &&
    (typeof target === 'string' ? isPropValid(prop) : true),
};

export const Horizontal = styled.div.withConfig(styleOnlyProps)<Props>`
  display: flex;
  align-items: center;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
  gap: ${({ gap = 1 }) => unitMapping[gap]};
  flex: ${({ grow }) => (grow ? '1' : 'initial')};
`;

export const SBHorizontal = styled.div.withConfig(styleOnlyProps)<
  Exclude<Props, 'center'>
>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ gap = 1 }) => unitMapping[gap]};
  flex: ${({ grow }) => (grow ? '1' : 'initial')};
`;

export const Vertical = styled.div.withConfig(styleOnlyProps)<Props>`
  display: flex;
  flex-direction: column;
  align-items: ${({ center }) => (center ? 'center' : 'stretch')};
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
  gap: ${({ gap = 1 }) => unitMapping[gap]};
  flex: ${({ grow }) => (grow ? '1' : 'initial')};
`;
